
import { AppConfig } from '../../environments/environment'

//
// store application preferences and AppConfig overrides after app deployed
//
// windows path example: appData/roaming/fes-testbed-client/testbed-settings.json
//

interface AppSettingsImpl {
    get(key:string,defaultValue:any)
    set(key:string,value:any)
}

export class AppSettings {

    impl : AppSettingsImpl = null

    constructor() {
        if (this.isElectron) {
            const ElectronStore = window.require('electron-store');
            this.impl = new ElectronStore({'name':'testbed-settings'})
        } else {
            this.impl = {
                get(key,defaultValue) {
                    let val = window.localStorage.getItem(key)
                    if ( val != null ) {
                        return val
                    }
                    return AppSettings.getByKey(AppConfig,key,defaultValue)
                },
                set(key, value) {
                    window.localStorage.setItem(key,value)
                }
            }
        }
    }

    static getByKey = function( obj : any, key: string, defaultValue = null) {
        const keyPath = key?.split('.')
        return AppSettings.getByKeyPath(obj,keyPath,defaultValue)
    }

    static getByKeyPath = function( obj : any, keyPath: string[], defaultValue = null) {
        for (var i = 0, n = keyPath.length; i < n; ++i) {
            var k = keyPath[i];
            if (k in obj) {
                obj = obj[k];
            } else {
                return defaultValue;
            }
        }
        return obj;
    }

    get( key, defaultValue) {
        return this.impl.get(key,defaultValue)
    }

    get isElectron(): boolean {
        return !!(window && window.process && window.process.type);
    }

    getLastUserName() : string {
        return this.impl.get('login.userName','')
    }    

    setLastUserName( userName : string ) : void {
        this.impl.set('login.userName', userName)
    }    
    
    getApiUrl() : string {
        return this.impl.get('config.apiUrl', AppConfig.apiUrl)
    }
    setApiUrl( url : string ) {
        this.impl.set('config.apiUrl', url)
    }

    getWsUrl() : string {
        return this.impl.get('config.wsUrl', AppConfig.wsUrl)
    }
    setWsUrl( url : string ) {
        this.impl.set('config.wsUrl', url)
    }

    getSyncUrl() : string {
        return this.impl.get('config.syncUrl', AppConfig.syncUrl)
    }
    setSyncUrl( url : string ) {
        this.impl.set('config.syncUrl', url)
    }

    getGraphQLUrl() : string {
        return this.impl.get('config.graphQLUrl', AppConfig.graphQLUrl)
    }
    setGraphQLUrl( url : string ) {
        this.impl.set('config.graphQLUrl', url)
    }

    getGraphQLWsUrl() : string {
        return this.impl.get('config.graphQLWsUrl', AppConfig.graphQLWsUrl)
    }

    getWsReconnectDelaySecs() : number {
        return Number.parseInt(this.impl.get('config.wsReconnectDelaySecs', AppConfig.wsReconnectDelaySecs))
    }
    setWsReconnectDelaySecs( secs : number ) {
        this.impl.set('config.wsReconnectDelaySecs', secs)
    }

    
    parseBoolean( strVal: string ) {
        return /^\s*(true|1|on)\s*$/i.test(strVal)
    }

    getWsPingIntervalSecs() : number {
        return Number.parseInt(this.impl.get('config.wsPingIntervalSecs', AppConfig.wsPingIntervalSecs))
    }
    setWsPingIntervalSecs( secs : number ) {
        this.impl.set('config.wsPingIntervalSecs', secs)
    }

    getEnvName() : string {
        return this.impl.get('config.environment',AppConfig.environment)
    }

    getRxdbUniquePrefix() : string {
        return this.impl.get('config.rxdbUniquePrefix', AppConfig.rxdbUniquePrefix)
    }

    getMaximizeWebcamViewEnabled() : boolean {
        return this.parseBoolean(this.impl.get('config.maximizeWebcamViewEnabled','true'))
    }
    setMaximizeWebcamViewEnabled( bVal : boolean ) {
        this.impl.set('config.maximizeWebcamViewEnabled', bVal)
    }

    getDefaultWebcamId() {
        return this.impl.get('config.defaultWebcamId',null)
    }
    setDefaultWebcamId( id:string ) {
        this.impl.set('config.defaultWebcamId', id)
    }

    getScoutRefDlgPlotterCssClass() {
        return this.impl.get('config.scoutRefDlgPlotterCssClass',null)
    }
    setScoutRefDlgPlotterCssClass( cssClass:string ) {
        this.impl.set('config.scoutRefDlgPlotterCssClass', cssClass)
    }

    getPathTestPointEditorPlotterCssClass() {
        return this.impl.get('config.pathTestPointEditorPlotterCssClass',null)
    }
    setPathTestPointEditorPlotterCssClass( cssClass:string ) {
        this.impl.set('config.pathTestPointEditorPlotterCssClass', cssClass)
    }


    // dialer
    getDialerGraphQLUrl() : string {
        return this.impl.get('config.dialer.graphQLUrl', AppConfig.dialer?.graphQLUrl)
    }
    getDialerGraphQLWsUrl() : string {
        return this.impl.get('config.dialer.graphQLWsUrl', AppConfig.dialer?.graphQLWsUrl)
    }


    getPathTestPointEditorUseDialer() {
        return this.parseBoolean(this.impl.get('config.pathTestPointEditorUseDialer','true'))
    }
    setPathTestPointEditorUseDialer( bUseDialer:boolean ) {
        this.impl.set('config.pathTestPointEditorUseDialer', bUseDialer)
    }

    getPathTestPointEditorUseBaro() {
        return this.parseBoolean(this.impl.get('config.pathTestPointEditorUseBaro','false'))
    }
    setPathTestPointEditorUseBaro( bUseBaro:boolean ) {
        this.impl.set('config.pathTestPointEditorUseBaro', bUseBaro)
    }

}